import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import Bande from './Bande';
import { ENTREPRISE, MACHINES } from '../data/site';
import { reinitialiserConsentement } from './consentement';

export default function Footer() {
  return (
    <footer className="bg-nuit text-white/70">
      <Bande hauteur={6} />
      <div className="conteneur py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 text-[15.5px] leading-relaxed">
              Location d'engins de chantier avec ou sans chauffeur, pour les professionnels
              du bâtiment, des travaux publics et de l'industrie. Livraison sur chantier
              dans toute l'Île-de-France.
            </p>
          </div>

          <div>
            <h4 className="text-jaune text-[13px] mb-4">Nos machines</h4>
            <ul className="space-y-2 text-[15.5px]">
              {MACHINES.map((m) => (
                <li key={m.slug}>
                  <Link to={`/nos-engins/${m.slug}`} className="hover:text-jaune transition-colors">
                    {m.nom}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/nos-engins" className="hover:text-jaune transition-colors">
                  Tout le parc et les accessoires
                </Link>
              </li>
            </ul>
          </div>


          <div>
            <h4 className="text-jaune text-[13px] mb-4">Nous joindre</h4>
            <ul className="space-y-3 text-[15.5px]">
              <li>
                <a href={ENTREPRISE.telephoneLien} className="font-display text-[22px] text-white hover:text-jaune transition-colors">
                  {ENTREPRISE.telephone}
                </a>
              </li>
              <li>
                <a href={ENTREPRISE.emailLien} className="hover:text-jaune transition-colors break-all">
                  {ENTREPRISE.email}
                </a>
              </li>
              <li>
                {ENTREPRISE.adresse}
                <br />
                {ENTREPRISE.codePostal} {ENTREPRISE.ville}
              </li>
              <li>{ENTREPRISE.horaires}</li>
            </ul>
            <Link to="/contact" className="btn-jaune mt-5 w-full sm:w-auto">
              Demander un devis
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-7 border-t border-white/12 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between text-[14px]">
          <p>© {ENTREPRISE.nom}. Tous droits réservés.</p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/mentions-legales" className="hover:text-jaune transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-jaune transition-colors">Confidentialité</Link>
            <Link to="/charte-avis" className="hover:text-jaune transition-colors">Charte des avis</Link>
              <span aria-hidden="true">·</span>
              <Link to="/cookies" className="hover:text-jaune transition-colors">Cookies</Link>
            <button
              type="button"
              onClick={reinitialiserConsentement}
              className="hover:text-jaune transition-colors text-left"
            >
              Gérer mes cookies
            </button>
            <Link to="/faq" className="hover:text-jaune transition-colors">FAQ</Link>
            <Link to="/contact" className="hover:text-jaune transition-colors">Contact</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
